/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import { Game } from "./Game";

export class GameFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<Game> {
    return super.deploy(overrides || {}) as Promise<Game>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Game {
    return super.attach(address) as Game;
  }
  connect(signer: Signer): GameFactory {
    return super.connect(signer) as GameFactory;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Game {
    return new Contract(address, _abi, signerOrProvider) as Game;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftishka",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nftIx",
        type: "uint256",
      },
    ],
    name: "PrizeTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "ds",
        type: "address[]",
      },
    ],
    name: "addDepositors",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "buyTicket",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "currPlayer",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ERC721[]",
        name: "_nfts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositors",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "i",
        type: "uint8",
      },
    ],
    name: "entropy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8[256]",
        name: "op",
        type: "uint8[256]",
      },
      {
        internalType: "uint8",
        name: "startIx",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "endIx",
        type: "uint8",
      },
    ],
    name: "finito",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8[255]",
        name: "_playersOrder",
        type: "uint8[255]",
      },
      {
        internalType: "uint32",
        name: "_lastAction",
        type: "uint32",
      },
    ],
    name: "initEnd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "numCalls",
        type: "uint8",
      },
      {
        internalType: "uint256[]",
        name: "ourEntropy",
        type: "uint256[]",
      },
    ],
    name: "initStart",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "nfts",
    outputs: [
      {
        internalType: "address",
        name: "adr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "i",
        type: "uint8",
      },
    ],
    name: "player",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "players",
    outputs: [
      {
        internalType: "uint8",
        name: "numPlayers",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "rawFulfillRandomness",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "v",
        type: "uint256",
      },
    ],
    name: "setTicketPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "spaws",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_sender",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_from",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "missed",
        type: "uint8",
      },
    ],
    name: "steal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "swaps",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "thinkTime",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ticketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeBeforeGameStart",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "missed",
        type: "uint8",
      },
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "withdrawERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ERC721",
        name: "nft",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "withdrawERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawEth",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";
